import Middleware from '../middleware/editable';
import IECell from './inline-edit-cell';
import ColumnDataStorage from "./data-storage";
import { getEditableValues } from "../helpers/ajax";
import { getIdFromTableRow, getRowCellByName } from "AC/helpers/table";
var InlineEdit = /** @class */ (function () {
    function InlineEdit(Table, Editables, enabled, version) {
        this.Editables = Editables;
        this.Table = Table;
        this.Middleware = new Middleware(this.Editables);
        this._enabled = enabled;
        this._version = version;
        this._initialised = false;
        this._open_editables = [];
        this._setTableClass();
        this._addEvents();
        this._initCells();
        this._setInputState();
    }
    InlineEdit.prototype.isEnabled = function () {
        return this._enabled;
    };
    InlineEdit.prototype.getVersion = function () {
        return this._version;
    };
    InlineEdit.prototype.enable = function () {
        this._enabled = true;
        this._storePreference();
        this._setTableClass();
        this._initCells();
        this._setInputState();
    };
    InlineEdit.prototype._setInputState = function () {
        var input = document.getElementById('acp-enable-editing');
        if (input) {
            input.checked = this.isEnabled();
        }
    };
    InlineEdit.prototype.disable = function () {
        this._enabled = false;
        this._storePreference();
        this._setTableClass();
    };
    /**
     * @param {Boolean} initialized
     * @returns {InlineEdit}
     */
    InlineEdit.prototype.setInitialised = function (initialized) {
        if (initialized === void 0) { initialized = true; }
        this._initialised = initialized;
        return this;
    };
    /**
     * @returns {boolean}
     */
    InlineEdit.prototype.isInitialised = function () {
        return this._initialised;
    };
    InlineEdit.prototype._setTableClass = function () {
        var table = this.Table.el;
        table.classList.add('acp-ie-table');
        table.classList.add('acp-ie-table--' + this.getVersion());
        if (this.isEnabled()) {
            table.classList.add('acp-ie-enabled');
            table.classList.remove('acp-ie-disabled');
        }
        else {
            table.classList.add('acp-ie-disabled');
            table.classList.remove('acp-ie-enabled');
        }
    };
    InlineEdit.prototype._initCells = function () {
        var _this = this;
        if (this.isInitialised() || !this.isEnabled()) {
            return;
        }
        var columns = this.Table.Columns.getColumns();
        Object.keys(columns).forEach(function (column_name) {
            var settings = columns[column_name];
            if (!settings || !settings.editable || !settings.editable.type) {
                return;
            }
            var middleware = _this.Middleware.get(settings);
            var editable = middleware.getEditable();
            if (!editable) {
                console.info(settings.editable.type + " does not exist or is not loaded");
                return;
            }
            _this.Table.Cells.getByName(column_name).forEach(function (cell) {
                if (cell.hasOwnProperty('IEdit')) {
                    return;
                }
                if (cell.dataStorage) {
                    cell.IEdit = new IECell(_this, cell, middleware, editable);
                }
            });
        });
        this.setInitialised();
    };
    /**
     * Init a Single Cell
     * @param cell
     */
    InlineEdit.prototype.initCell = function (cell) {
        var settings = cell.getSettings();
        if (!settings || !settings.editable || !settings.editable.type || !settings.editable.inline_edit || cell.hasOwnProperty('IEdit')) {
            return;
        }
        var middleware = this.Middleware.get(settings);
        var editable = middleware.getEditable();
        if (!editable) {
            return;
        }
        if (!cell.dataStorage) {
            cell.dataStorage = new ColumnDataStorage({ column_name: cell.getName(), id: cell.getObjectID() });
        }
        cell.IEdit = new IECell(this, cell, middleware, editable);
    };
    InlineEdit.prototype.initRow = function (id) {
        var self = this;
        getEditableValues([id]).done(function (response) {
            response.data.editable_values.forEach(function (item) {
                var cell = self.Table.Cells.get(item.id, item.column_name);
                self.initCell(cell);
                if (cell.IEdit && cell.IEdit.hasOwnProperty('Editable')) {
                    cell.IEdit.Editable.setValue(item.value);
                }
            });
        });
    };
    InlineEdit.prototype.updateRowCells = function (e) {
        var _this = this;
        var row = e.target;
        var id = getIdFromTableRow(row);
        var columns = this.Table.Columns.getColumns();
        Object.keys(columns).forEach(function (column_name) {
            var cell = _this.Table.Cells.get(id, column_name);
            if (cell) {
                cell.el = getRowCellByName(row, column_name);
                if (cell.IEdit) {
                    cell.IEdit.afterSetValue();
                }
            }
        });
    };
    InlineEdit.prototype._storePreference = function () {
        var value = this.isEnabled() ? 1 : 0;
        return jQuery.post(ajaxurl, {
            action: 'acp_editing_single_request',
            method: 'editability_state',
            value: value,
            list_screen: AC.list_screen,
            layout: AC.layout,
            _ajax_nonce: AC.ajax_nonce
        });
    };
    InlineEdit.prototype._addEvents = function () {
        var _this = this;
        var self = this;
        var input = document.getElementById('acp-enable-editing');
        if (input) {
            input.addEventListener('change', function () {
                if (input.checked) {
                    self.enable();
                }
                else {
                    self.disable();
                }
            });
        }
        document.addEventListener('ACP_InlineEditing_Close', function () {
            _this.closeOpenEditables();
        });
        this.updateRowCell = this.updateRowCells.bind(this);
        jQuery(this.Table.el).on('updated', 'tr', this.updateRowCell);
    };
    InlineEdit.prototype.closeOpenEditables = function () {
        this._open_editables.forEach(function (editable) {
            editable.close();
        });
        this._open_editables = [];
    };
    return InlineEdit;
}());
export default InlineEdit;
